var _rect, _path, _rect2, _path2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRt05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.66699,
    y: 9.16675,
    width: 16.6667,
    height: 1.66667,
    rx: 0.666667,
    fill: "#737A83"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 6.66675H16.833C17.2012 6.66675 17.4997 6.96522 17.4997 7.33341V12.6667C17.4997 13.0349 17.2012 13.3334 16.833 13.3334H15.833V6.66675Z",
    fill: "#FFBC80"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.333,
    y: 5,
    width: 2.5,
    height: 10,
    rx: 0.666667,
    fill: "#FFA757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.33341C2.5 6.96522 2.79848 6.66675 3.16667 6.66675H4.16667V13.3334H3.16667C2.79848 13.3334 2.5 13.0349 2.5 12.6667V7.33341Z",
    fill: "#FFBC80"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16699,
    y: 5,
    width: 2.5,
    height: 10,
    rx: 0.666667,
    fill: "#FFA757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRt05);
export default __webpack_public_path__ + "static/media/icon_RT05.f4e227992d0c73b89eb93e40c444e867.svg";
export { ForwardRef as ReactComponent };